import { createContext, useContext } from 'react';
import type { WebSocketEventRouter } from '@shared/websocket/router';

export interface WebSocketContextType {
  isConnected: boolean;
  send: (data: unknown) => void;
  registerHandlers: (register: (router: WebSocketEventRouter) => () => void) => () => void;
}

export const WebSocketContext = createContext<WebSocketContextType | undefined>(undefined);

export function useWebSocketContext(): WebSocketContextType {
  const context = useContext(WebSocketContext);

  if (!context) {
    throw new Error('useWebSocketContext must be used within WebSocketProvider');
  }

  return context;
}


